var CreImage = require('./creImage');

/**
 * Treat like an image but this is actually an iframe with the page source.
 * Bypasses any need to get a url to load from the CRE.
 * Currently used for URL page, formsIQ page, and GOS html pages (in page mode).
 */


module.exports = CreImage.extend({

    tagName: 'iframe',

    attributes: function() {

        var attrs = {
            frameborder: '0'
        };

        // May want to white list others ...

        // DVBC-989
        if ( this.model.isGosHtmlFile() ) {
            attrs['sandbox'] = '';  // note: will disallow getting the size on load for resize
        }

        return attrs;

    },
    className: function() {
        return CreImage.prototype.className + ' FV-pgIframe';
    },
    loadImg: function(url) {

        // Note: not in DOM when src is set (!)
        this.$el.attr('src', url);

        /**
         * Manually trigger isLoaded b/c 'load' event of iframe won't fire if it's not in the DOM.
         * - DVBC-1128: load indicator is shown but the quickly covered up bc of this while the content of the iframe is loading in the DOM.
         * - this whole workflow should be fixed (eg load in hidden tag, not append to DOM) ...
         */

        this.model.set({'isLoaded': true});
    },

    /**
     * Looks like this was an attempt to determine if the url was on a different domain or if
     * an x-frame-option was set from the browser.
     * For now not using -- unable to determine if X-FRAME-OPTION is set from the browser -- leave commented out.
     * This will fail hard (I don't think a good solution).
     * See urlPage _appendErrorViewInDOM .
     * See related issue: DVBC-1703 -- a related issue trying to cache 'error' event from an iframe ( not possible ).
     */

  /*
    imgLoaded: function() {

        /!**
         * handle X-FRAME-OPTIONS set to SAME-ORIGIN in the success callback -- error won't be called in this case
         * this is currently the default in Feith setup -- can be configured differently
         * TODO -- issue: differentiate between cross origin and xdomain option
         * I don't think possible without server or extreme hack.
         * Presumably the below was to check if cross-domain ... it should not work for catching load errors ( DVBC-1703 )
         *!/

          try {

            // var x = this.el.contentDocument || this.el.contentWindow.document;
            // former will break if XDOMAIN in chrome; latter firefox and IEs (tested 9-11) -- NO: THIS WILL ALSO BREAK ONES THAT DO WORK

              var src = this.el.src;

            } catch(err) {


                this.model.trigger('imgLoadError');
                return;
            }

        CreImage.prototype.imgLoaded.apply(this, arguments);

        // can access this.el.src ... but not contentWindow .... (was allowed to in insecure mode, ugh)

        this.model.get('url') === this.el.src // No, not reliable: can be redirected; http to https
            ? CreImage.prototype.imgLoaded.apply(this, arguments)
            : this.model.trigger('imgLoadError');

    }
*/

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/urlFrame.js
 ** module id = 456
 ** module chunks = 0
 **/